import type { ReactNode } from 'react';

export function Card({
  children,
  elevated = false,
  className,
}: {
  children: ReactNode;
  elevated?: boolean;
  className?: string;
}) {
  return (
    <div className={`ds-card${elevated ? ' ds-card--elevated' : ''}${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}

type BodySize = 'sm' | 'md' | 'lg';

export function CardBody({
  children,
  size = 'md',
}: {
  children: ReactNode;
  size?: BodySize;
}) {
  const cls = `ds-card__body${size !== 'md' ? ` ds-card__body--${size}` : ''}`;
  return <div className={cls}>{children}</div>;
}

export function CardHeader({ children }: { children: ReactNode }) {
  return <div className="ds-card__header">{children}</div>;
}

export function CardFooter({ children }: { children: ReactNode }) {
  return <div className="ds-card__footer">{children}</div>;
}
